import React, { FC, useEffect, useState } from 'react';
import {
  Modal,
  ButtonGroupWrapper,
  ButtonGroupPrimary,
  FilledButton,
  OutlinedButton,
  ModalHeading,
} from '@sainsburys-tech/luna-react';
import { ApolloError } from '@apollo/client';
import { NotificationType } from 'src/enums/notificationTypes.enum';
import { ProfileCard_ProfileInfoFragment } from 'src/operations/generated/graphql';

interface IFeedback {
  notificationFor: 'RESYNC';
  type: NotificationType;
}

interface IResyncProfileEmailPopup {
  handleConfirmation: (status: any) => Promise<void>;
  setFeedBackMessage: (status: IFeedback) => void | null;
  loading: boolean;
  error: ApolloError | undefined;
  setShowResyncPopup: (status: boolean) => void;
  profile: ProfileCard_ProfileInfoFragment;
  showResyncPopup: Boolean;
}

export const ResyncProfileEmailPopup: FC<IResyncProfileEmailPopup> = ({
  profile,
  handleConfirmation,
  setFeedBackMessage,
  loading,
  error,
  showResyncPopup,
  setShowResyncPopup,
}) => {
  const { id, firstName, lastName } = profile;

  const handleReset = () => {
    setShowResyncPopup(false);
  };

  const handleSubmit = (id: string) => {
    handleConfirmation(id);
    handleReset();
    setFeedBackMessage({
      notificationFor: 'RESYNC',
      type: NotificationType.SUCCESS,
    });
  };
  useEffect(() => {
    if (error) {
      setFeedBackMessage({
        notificationFor: 'RESYNC',
        type: NotificationType.FAILURE,
      });
    }
  }, [error]);
  return (
    <>
      <Modal
        restrictClose
        open={showResyncPopup}
        headingId='select-account-confirmation'
      >
        <ModalHeading
          element='h3'
          className='name-modal'
        >{`You're about to resync ${firstName} ${lastName}'s profile. Do you want to continue?`}</ModalHeading>
        <ButtonGroupWrapper className='ln-u-margin-left'>
          <ButtonGroupPrimary>
            <FilledButton
              className='ln-u-margin-right'
              onClick={() => handleSubmit(id)}
            >
              Confirm
            </FilledButton>
            <OutlinedButton
              onClick={() => {
                handleReset();
              }}
            >
              Cancel
            </OutlinedButton>
          </ButtonGroupPrimary>
        </ButtonGroupWrapper>
      </Modal>
    </>
  );
};
